export default __webpack_public_path__ + "static/ndp1-f1269740675c1b0d55592a1539e905ca.jpg";